import { RoutePaths } from '../../constants';

/** Роуты, для которых применяется светлая тема (белый цвет элементов) */
export const LIGHT_THEME_ROUTES = [RoutePaths.Main, `${RoutePaths.Category}/`, RoutePaths.Prompt] as const;

export const isLightThemeRoute = (pathname: string) => {
    return LIGHT_THEME_ROUTES.some(route => {
        if (route === RoutePaths.Main) {
            return pathname === route;
        }

        return pathname.startsWith(route);
    });
};
